var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * API service for Inspection Status lookup
 */
import api from '@utils/axios';
class InspectionStatusService {
    /**
     * Fetches all inspection statuses from the API
     */
    static getInspectionStatuses() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield api.get(this.BASE_URL);
                return response.data.data.map((status) => ({
                    id: status.value,
                    name: status.label,
                    value: status.value,
                    color: status.color,
                    icon: status.icon
                }));
            }
            catch (error) {
                console.error('Error fetching inspection statuses:', error);
                throw error;
            }
        });
    }
}
InspectionStatusService.BASE_URL = '/api/internal/inspection_statuses';
export default InspectionStatusService;
